/*
 * (c) Copyright, 2022, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { setLocale, object, number, string, boolean, date } from 'yup'
import Validation from '~/lib/Validation'

export const Role = {
  ADMIN: 'ADMIN',
  CONTENT_ADMIN: 'CONTENT_ADMIN',
  POWER_USER: 'POWER_USER',
  USER: 'USER',
  AUDITOR: 'AUDITOR',
  INSPECTOR: 'INSPECTOR',
  EXTERNAL: 'EXTERNAL',
  CLOUD_ADMIN_ROLE: 'CLOUD_ADMIN_ROLE',
  RCR_USER: 'RCR_USER',
  ETMF_MANAGER: 'ETMF_MANAGER',
  ETMF_SPECIALIST: 'ETMF_SPECIALIST',
  ETMF_SITE_USER: 'ETMF_SITE_USER',
  ETMF_STUDY_USER: 'ETMF_STUDY_USER',
  ETMF_SPONSOR: 'ETMF_SPONSOR'
}

const ValidationSchema = () => {
  setLocale(Validation.general)
  return object().shape({
    id: number().nullable(),
    firstName: string()
      .trim()
      .max(255)
      .required()
      .default(() => ''),
    lastName: string()
      .trim()
      .max(255)
      .required()
      .default(() => ''),
    department: string()
      .max(255)
      .nullable()
      .default(() => ''),
    title: string()
      .max(255)
      .nullable()
      .default(() => ''),
    accountName: string()
      .max(255)
      .required()
      .default(() => ''),
    email: string()
      .email('INVALID_BOX_EMAIL_MSG')
      .max(255)
      .required()
      .nullable()
      .default(() => ''),
    role: string()
      .required()
      .nullable()
      .oneOf(Object.values(Role))
      .default(() => Role.ADMIN),
    temporaryUser: boolean()
      .nullable()
      .default(() => false),
    serviceAccount: boolean()
      .nullable()
      .default(() => false),
    expiresAt: date()
      .nullable()
      .default(() => null)
      .when('temporaryUser', {
        is: true,
        then: (schema: any) => schema.required(),
        otherwise: (schema: any) => schema.nullable()
      })
  })
}

export default ValidationSchema
